var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1044"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2201",
    width: 32,
    height: 32,
    rx: 8,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2158 8C22.2158 8 22.9431 9.54546 22.3068 10.7273C22.3068 10.7273 23.7613 12.0909 23.2158 15C22.7033 17.7336 20.3067 18.4546 18.7613 18.4546C18.7613 18.4546 19.3777 18.9957 19.3976 19.9091C19.4056 20.2733 19.3976 21.3636 19.3976 21.3636V24H13.9431V21.3636C12.4885 21.7273 11.034 21.1818 10.7613 20.5455C10.4885 19.9091 9.76125 18.8182 9.76125 18.8182C8.76125 18.3636 9.03397 18.0909 9.03397 18.0909C9.94306 17.6364 10.8522 18.8182 10.8522 18.8182C10.8522 18.8182 11.3067 19.7273 12.2158 20.0909C13.1249 20.4546 14.034 19.9091 14.034 19.9091C13.9431 19 14.5794 18.4546 14.5794 18.4546C13.034 18.4546 10.6375 17.7337 10.1249 15C9.57944 12.0909 11.034 10.7273 11.034 10.7273C10.3976 9.54546 11.1249 8 11.1249 8C12.7613 8 13.9431 9.0909 13.9431 9.0909C14.5795 8.72726 16.6704 8.72726 16.6704 8.72726C16.6704 8.72726 18.7613 8.72726 19.3976 9.0909C19.3976 9.0909 20.5795 8 22.2158 8Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub1);
export default __webpack_public_path__ + "static/media/github1.7b0503336ecb31cff3642138e82d4a78.svg";
export { ForwardRef as ReactComponent };